var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Dropzone from "react-dropzone";
import padding from "../global/padding";
export default styled(Dropzone)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  margin-bottom: ", ";\n  border-width: 2px;\n  border-color: #666;\n  border-style: dashed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 15px;\n"], ["\n  ",
    "\n  margin-bottom: ", ";\n  border-width: 2px;\n  border-color: #666;\n  border-style: dashed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 15px;\n"])), function (_a) {
    var width = _a.width, height = _a.height;
    return "\n    width: " + (width || "100%") + ";\n    height: " + (height || "250px") + ";\n  ";
}, padding.base);
var templateObject_1;
